import { useEffect } from 'react';
import { subscribeTagReads } from '../services/scannerService';
import { useRawScanStore } from '../stores/rawScanStore';

/** Hardware TagRead → raw scan pool (no document / material matching). */
export function useRawScanSubscription(enabled: boolean) {
  const ingestRawTag = useRawScanStore((s) => s.ingestRawTag);

  useEffect(() => {
    if (!enabled) return;
    return subscribeTagReads((tagId) => ingestRawTag(tagId));
  }, [enabled, ingestRawTag]);
}
